import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Brand from "@/components/Brand";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api, { extractErr } from "@/lib/api";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true, ok: false, msg: "" });

  useEffect(() => {
    if (!token) { setState({ loading: false, ok: false, msg: "Missing verification token." }); return; }
    api.post("/auth/email/verify", { token })
      .then(({ data }) => setState({ loading: false, ok: true, msg: data.email || "" }))
      .catch((err) => setState({ loading: false, ok: false, msg: extractErr(err) }));
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center p-6">
      <div className="w-full max-w-md text-center">
        <div className="mb-6 flex justify-center"><Brand variant="dark" size="md" /></div>
        {state.loading ? (
          <div className="p-8 rounded-2xl bg-slate-900 border border-slate-800" data-testid="verify-loading">
            <Loader2 className="w-8 h-8 mx-auto animate-spin text-slate-400" />
            <div className="mt-3 text-slate-300">Verifying your email…</div>
          </div>
        ) : state.ok ? (
          <div className="p-8 rounded-2xl bg-emerald-500/10 border border-emerald-500/30" data-testid="verify-ok">
            <CheckCircle2 className="w-10 h-10 mx-auto text-emerald-400" />
            <h1 className="mt-3 font-display text-2xl font-bold text-emerald-100">Email verified</h1>
            <p className="mt-2 text-emerald-200/80 text-sm">Your email is now confirmed. You'll receive order updates and notifications here.</p>
            <div className="mt-6 flex gap-2 justify-center">
              <Link to="/admin" data-testid="verify-to-admin" className="px-4 py-2 rounded-full bg-orange-500 hover:bg-orange-600 text-slate-900 font-semibold text-sm">Go to admin</Link>
              <Link to="/" data-testid="verify-to-home" className="px-4 py-2 rounded-full border border-slate-700 text-slate-200 text-sm">Home</Link>
            </div>
          </div>
        ) : (
          <div className="p-8 rounded-2xl bg-red-500/10 border border-red-500/30" data-testid="verify-err">
            <XCircle className="w-10 h-10 mx-auto text-red-400" />
            <h1 className="mt-3 font-display text-2xl font-bold text-red-100">Verification failed</h1>
            <p className="mt-2 text-red-200/80 text-sm">{state.msg}</p>
            <div className="mt-6"><Link to="/admin" data-testid="verify-back" className="px-4 py-2 rounded-full border border-slate-700 text-slate-200 text-sm">Back to admin</Link></div>
          </div>
        )}
      </div>
    </div>
  );
}
